// FF stands for Feature Flag
export const FF_HIBOB_FONTS = 'hibob-fonts'; // DO NOT REMOVE
export const FF_MAAR_FONTS = 'maar-fonts'; // DO NOT REMOVE
export const FF_KEY_NAVIGATION = 'key-navigation';
export const FF_ALEPH_FONTS = 'aleph-fonts'; // DO NOT REMOVE
export const FF_RAKUTEN_FONTS = 'rakuten-fonts'; // DO NOT REMOVE
export const FF_SCRIBOS_FONTS = 'scribos-fonts'; // DO NOT REMOVE
export const FF_DEPOSCO_FONTS = 'deposco-fonts'; // DO NOT REMOVE
export const FF_EMPIK_FONTS = 'empik-fonts'; // DO NOT REMOVE
export const FF_BARKBOX_FONTS = 'barkbox-fonts'; // DO NOT REMOVE
export const FF_KOMFI_FONTS = 'komfi-health-fonts'; // DO NOT REMOVE
export const FF_VMFOOTWEAR_FONTS = 'vmfootwear-fonts'; // DO NOT REMOVE
export const FF_JOURNEYFURTHER_FONTS = 'journeyfurther-fonts'; // DO NOT REMOVE
export const FF_NOBEARS_FONTS = 'nobears-fonts'; // DO NOT REMOVE
export const FF_NVIDIA_FONTS = 'nvidia-fonts'; // DO NOT REMOVE
export const FF_OPERA_FONTS = 'opera-fonts'; // DO NOT REMOVE
export const FF_SAMURAI_FONTS = 'samur-ai-fonts'; // DO NOT REMOVE
export const FF_VOLVO_FONTS = 'volvo-fonts'; // DO NOT REMOVE
export const FF_SAMY_FONTS = 'samy-fonts'; // DO NOT REMOVE
export const FF_BUSUU_FONTS = 'busuu-fonts'; // DO NOT REMOVE
export const FF_SPAFAX_FONTS = 'spafax-fonts'; // DO NOT REMOVE
export const FF_TEAM5PM_FONTS = 'team5pm-fonts'; // DO NOT REMOVE
export const FF_LLBEAN_FONTS = 'llbean-fonts'; // DO NOT REMOVE
export const FF_A16Z_FONTS = 'a16z-fonts'; // DO NOT REMOVE
export const FF_PUNKLE_FONTS = 'punkle-fonts'; // DO NOT REMOVE
export const FF_PREDATOR_GROUP_FONTS = 'predator-group-fonts'; // DO NOT REMOVE
export const FF_STRATEYRANT_FONTS = 'strategyrant-fonts'; // DO NOT REMOVE
export const FF_DUNLOP_FONTS = 'dunlop-fonts'; // DO NOT REMOVE
export const FF_AND_OR_FONTS = 'and-or-fonts'; // DO NOT REMOVE
export const FF_LINDEX_FONTS = 'lindex-fonts'; // DO NOT REMOVE
export const FF_JAN_GERICKE_FONTS = 'jan-gericke-fonts'; // DO NOT REMOVE
export const FF_METROPOLIS_FONTS = 'metropolis-fonts'; // DO NOT REMOVE
export const FF_AROSOLUCIONES_FONTS = 'arosoluciones-fonts'; // DO NOT REMOVE
export const FF_MINTHC_FONTS = 'minthc-fonts'; // DO NOT REMOVE
export const FF_WOLFE_FONTS = 'wolfe-fonts'; // DO NOT REMOVE
export const FF_META_CREATIVE_X_FONTS = 'meta-creative-x-fonts'; // DO NOT REMOVE
export const FF_POLYMATHTEXT_FONTS = 'polymathtext-fonts'; // DO NOT REMOVE
export const FF_JOURNEY_FONTS = 'journey-fonts'; // DO NOT REMOVE
export const FF_ENCENDER_FONTS = 'encender-fonts'; // DO NOT REMOVE
export const FF_EUCLID_SQUARE_FONTS = 'euclid-square-fonts'; // DO NOT REMOVE
export const FF_OPG_FONTS = 'opg-fonts'; // DO NOT REMOVE
export const FF_HOLIDAY_PROMO_BANNER = 'holiday-promo-banner'; // DO NOT REMOVE - for displaying a promo banner on the pricing page and pricing modal
export const FF_TEXT_ITERATOR = 'text-iterator';
export const FF_NODE_GROUPING = 'node-grouping';
export const FF_REMOVE_FROM_GROUP_WITH_MODIFIER = 'remove-from-group-with-modifier';
export const FF_CLIENT_OLD_VERSION_RELOAD = 'client-old-version-reload'; // DO NOT REMOVE
export const FF_SOCKET_RECONNECTION_ISSUE = 'socket-reconnection-issue';
export const FF_LOG_SOCKET_EVENTS = 'log-socket-events'; // DO NOT REMOVE
export const FF_SWIPE_TO_DELETE_EDGE = 'swipe-to-delete-edge';
export const FF_PROXIMITY_CONNECT = 'proximity-connect';
export const FF_COMP_TIMELINE_DISPLAY = 'comp-timeline-display';
export const FF_TERMS_OF_SERVICE = 'terms-of-service';
export const FF_RUN_ITERATORS_WITH_NODES_TRAVERSAL = 'run-iterators-with-nodes-traversal';
export const FF_COMPARISON_NODE = 'comparison-node';
export const FF_POINTCLOUD_FROM_DEPTH = 'pointcloud-from-depth';
export const FF_FIGMA_COMPOSITOR = 'weave-figma-compositor';
export const FF_IMPORT_MODEL_IMAGE_URLS_INPUT = 'import-model-image-urls-input';
export const FF_NANO_BANANA_PRO_ERRORS = 'nano-banana-pro-errors';
export const FF_BLOCK_ANTHROPIC_MODELS_ANY_LLM = 'block-anthropic-models-anyllm';

export const FF_AUTO_ADD_INPUT_HANDLE = 'auto-add-input-handle';
export const FF_PACK_UNPACK_NODE = 'pack-unpack-node';
export const FF_CREDIT_THRESHOLD_ALERTS = 'credit-threshold-alerts';
export const FF_DISABLE_SHARE_FOR_FREE_USERS = 'disable-share-for-free-users';
/** Multivariate experiment variant: only this value disables share for free users; all others = control (default). */
export const FF_DISABLE_SHARE_FOR_FREE_USERS_VARIANT_TEST = 'test';
export const FF_DOUBLE_CLICK_TO_CREATE_ROUTER = 'double-click-to-create-router-node';
export const FF_SUBFLOWS_SAVED_NODES = 'subflows-saved-nodes';
